var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: _vm.uid + "cellId" } }, [
          _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.cellId")))
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            id: _vm.uid + "cellId",
            options: _vm.cellStore.cellsForVSelect,
            label: "name",
            reduce: cell => cell.id,
            clearable: true,
            disabled: _vm.disabled
          },
          model: {
            value: _vm.tracker.fkCellId,
            callback: function($$v) {
              _vm.$set(_vm.tracker, "fkCellId", $$v)
            },
            expression: "tracker.fkCellId"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "imei" } }, [
        _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.imei")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.tracker.imei,
            expression: "tracker.imei"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text", id: _vm.uid + "imei", disabled: _vm.disabled },
        domProps: { value: _vm.tracker.imei },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.tracker, "imei", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: _vm.uid + "type" } }, [
          _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.type")))
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            id: _vm.uid + "type",
            options: ["RMT700", "RJT707", "RFMC003"],
            clearable: false,
            disabled: _vm.disabled
          },
          model: {
            value: _vm.tracker.type,
            callback: function($$v) {
              _vm.$set(_vm.tracker, "type", $$v)
            },
            expression: "tracker.type"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "apn" } }, [
        _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.apn")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.tracker.apn,
            expression: "tracker.apn"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text", id: _vm.uid + "apn", disabled: _vm.disabled },
        domProps: { value: _vm.tracker.apn },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.tracker, "apn", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "apnUser" } }, [
        _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.apnUser")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.tracker.apnUser,
            expression: "tracker.apnUser"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: _vm.uid + "apnUser",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.tracker.apnUser },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.tracker, "apnUser", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "apnPassword" } }, [
        _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.apnPassword")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.tracker.apnPwd,
            expression: "tracker.apnPwd"
          }
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          id: _vm.uid + "apnPassword",
          disabled: _vm.disabled
        },
        domProps: { value: _vm.tracker.apnPwd },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.tracker, "apnPwd", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", { attrs: { for: _vm.uid + "mode" } }, [
          _vm._v(_vm._s(_vm.$t("map.gps.tracker.model.mode")))
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            id: _vm.uid + "mode",
            options: ["AUTO"],
            clearable: false,
            disabled: _vm.disabled
          },
          model: {
            value: _vm.tracker.mode,
            callback: function($$v) {
              _vm.$set(_vm.tracker, "mode", $$v)
            },
            expression: "tracker.mode"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }